// @ts-nocheck
import ReservationApi from "./ReservationApi";
// import { CHAUFFEUR_KEY } from "../apiKeys";
import { CreditCard } from "../../../interfaces/CreditCard";
// import LogicService from '../../../services/logic/LogicService';
//import reservationPhase from '../../../services/logic/ReservationLogic'; //undefined, wtf?

import { CHAUFFEUR_KEY } from '../apiKeys';


const transformReservation = (originalReservation: any) => {
  if (!originalReservation || originalReservation.length === 0) {
    return null;
  }

  const reservation = Object.assign({}, originalReservation);

  reservation.vehicle.currentLocation = {
    //address: reservation.vehicle.homeAddress,
    latitude: reservation.vehicle.currentLatitude,
    longitude: reservation.vehicle.currentLongitude
  };

  reservation.vehicle.homeLocation = {
    address: reservation.homeLocation.address,
    areaCity: reservation.homeLocation.area && reservation.homeLocation.area.length > 0 ? reservation.homeLocation.area + ", " + reservation.homeLocation.city : reservation.homeLocation.city,
    city: reservation.homeLocation.city,
    descriptions: reservation.homeLocation.descriptions,
    latitude: reservation.homeLocation.coordinates.latitude,
    longitude: reservation.homeLocation.coordinates.longitude,
    notes: reservation.homeLocation.notes,
    poorGps: reservation.homeLocation.poorGps,
    accessCode: reservation.homeLocation.accessCode,
    accessCodeInstructionsEn: reservation.homeLocation.accessCodeInstructionsEn,
    accessCodeInstructionsFi: reservation.homeLocation.accessCodeInstructionsFi,
    automatic: reservation.homeLocation.automatic,
    charger : reservation.homeLocation.charger,
    inside: reservation.homeLocation.inside
  };

  if (reservation.returnLocation) {
    reservation.vehicle.returnLocation = {
      address: reservation.returnLocation.address,
      areaCity: reservation.returnLocation.area && reservation.returnLocation.area.length > 0 ? reservation.returnLocation.area + ", " + reservation.returnLocation.city : reservation.returnLocation.city,
      city: reservation.homeLocation.city,
      descriptions: reservation.returnLocation.descriptions,
      latitude: reservation.returnLocation.coordinates.latitude,
      longitude: reservation.returnLocation.coordinates.longitude,
      notes: reservation.returnLocation.notes,
      accessCode: reservation.returnLocation.accessCode,
      accessCodeInstructionsEn: reservation.returnLocation.accessCodeInstructionsEn,
      accessCodeInstructionsFi: reservation.returnLocation.accessCodeInstructionsFi
    }
  }
  
  if (reservation.phase === "ONGOING") {
    reservation.phase = 1;//reservationPhase.IN_PROGRESS;
  } else if (reservation.phase === "FINISHED") {
    reservation.phase = 2;//reservationPhase.FINISHED;
  } else {
    reservation.phase = 0;// reservationPhase.UNSTARTED;
  }
      
  if (reservation.vehicle.fuelType === 'gas') {
    reservation.vehicle.fuelType = '95 E10'
  }

  delete reservation.vehicle.homeAddress;
  delete reservation.vehicle.currentLatitude;
  delete reservation.vehicle.currentLongitude;

  // vey random, thanks BE team
  reservation.vehicle.boxCode = reservation.boxCode;
  reservation.vehicle.boxLocation = reservation.boxLocation;
  reservation.vehicle.keyLocation = reservation.keyLocation;

  return reservation;
};

const transformReservations = (originalReservations: any) => {
  const reservations: any[] = [];
  originalReservations?.forEach(originalReservation => {
    reservations.push(transformReservation(originalReservation));
  });

  return reservations;
};

class V3ReservationApi implements ReservationApi {
  fetchCustom: (
    url: string,
    options?: any,
    addAuthHeader?: boolean
  ) => Promise<any>;

  constructor(
    fetchC: (
      url: string,
      options?: any,
      addAuthHeader?: boolean
    ) => Promise<any>
  ) {
    this.fetchCustom = fetchC;
  }

  findReservations = (token?: string, jwt?: string) => {
    const fetchUrl = `/reservations`;
    if (token && jwt) {  
      return this.fetchCustom(fetchUrl, {
        headers: {
          Authorization: "Bearer " + token,
          jwt
        }
      }, true).then(reservations =>
        transformReservations(reservations)
      );
    }

    return this.fetchCustom(fetchUrl).then(reservations =>
      transformReservations(reservations)
    );
  };

  getReservation = (reservationId: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const fetchUrl = `/reservations/${reservationId}`;
    return this.fetchCustom(fetchUrl).then(reservation =>
      transformReservation(reservation)
    );
  };

  createReservation = (reservationProps: {}) => {
    const fetchUrl = `/reservations/create`;

    reservationProps.key = 'ijlkmnY76GhvhYzfd5%Vyvu1GR547b8m';
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(reservationProps) 
      },
    );
  }; 

  startReservation = (reservationId: number, versionString?: string) => {
    const fetchUrl = `/reservations/${reservationId}/start`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify({
          method: versionString ? `Chauffeur ${versionString}` : "Chauffeur"
        })
      },
    );
  };

  sendServiceNote = (
    reservationId: number,
    feedback: string,
    flag?: string
  ) => {
    // we include this Network: string when a network call fails at network level
    // not worth logging
    if (feedback.includes('Network: ')) {
      return new Promise(res => res('No need to log network fail'))
    }

    if (reservationId <= 0) {
      return new Promise(res => res('Reservation number is invalid'))
    }

    const fetchUrl = `/reservations/${reservationId}/messages`;

    if (removeFlagFromFeedback(feedback)) {
      flag = undefined;
    }

    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        // headers: {
        //   Authorization: "Bearer " + key,
        // },
        body: JSON.stringify({
          message: feedback,
          flag
        })
      },
      true
    );
  };

  sendReceiptEmail = (reservationId: number) => {
    const fetchUrl = `/reservations/${reservationId}/email-receipt`;
    return this.fetchCustom(fetchUrl);
  }

  getReceiptPDF = (reservationId: number) => {
    const fetchUrl = `/reservations/${reservationId}/receipt`;
    return this.fetchCustom(fetchUrl);
  }


  sendSlackMessage = (channel_id: string, token: string, message: string, button?: {
    button_title: string,
    button_color: string
  }, file?: {
    file_attachment: string,
    file_name: string
  }) => {
    const fetchUrl = `/message/send-slack`;
    let button_title, button_color;
    if (button) {
      button_title = button.button_title;
      button_color = button.button_color;
    }
    let file_attachment, file_name;
    if (file) {
      file_attachment = file.file_attachment;
      file_name = file.file_name;
    }
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify({
          channel_id, token, message, button_title, button_color, file_attachment, file_name
        })
      },
    );

  }

  endReservation = (reservationId: number, versionString: string) => {
    const fetchUrl = `/reservations/${reservationId}/end`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify({
          method: versionString ? `Chauffeur ${versionString}` : "Chauffeur"
        })
      },
    );
  };

  lockVehicleDoors = (reservationId: number) => {
    const fetchUrl = `/reservations/${reservationId}/lock-doors`;
    return this.fetchCustom(fetchUrl, { method: "POST" });
  };

  unlockVehicleDoors = (reservationId: number) => {
    const fetchUrl = `/reservations/${reservationId}/unlock-doors`;
    return this.fetchCustom(fetchUrl, { method: "POST" });
  };

  getInspectionSheetUrl = (reservationId: number) => {
    const fetchUrl = `/reservations/${reservationId}/inspection-sheet`;
    return this.fetchCustom(fetchUrl);
  };

  postAnomalityForm = (reservationId: number, anomalityBoxValue: string) => {
    const fetchUrl = `/reservations/${reservationId}/messages`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify({
          message: anomalityBoxValue,
          messageType: "anomality",
          flag: "red"
        })
      },
    );
  };

  postFeedbackForm = (reservationId: number, boxValue: string) => {
    const fetchUrl = `/reservations/${reservationId}/messages`;
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify({
          message: boxValue,
          flag: "yellow"
        })
      },
    );
  };

  sendPictureForReservation = (reservationId: number, imageData: string, exifData?: any[]) => {
    const fetchUrl = `/reservations/${reservationId}/photos`;
    return this.fetchCustom(
      fetchUrl,
      { method: "POST", body: JSON.stringify({ photo: imageData, exifData }) },
    );
  };

  getPictureStatusForReservation = (reservationId: number, minutes?: number) => {
    const fetchUrl = `/reservations/${reservationId}/photos-stored-count`;
    const suffix = minutes ? `?minutes=${minutes}` : ''
    return this.fetchCustom(
      fetchUrl + suffix);
  };

  extendReservation = (
    reservationId: number,
    extendTime: number,
    creditCardInfo?: CreditCard
  ) => {
    const fetchUrl = `/reservations/${reservationId}/extend`;
    let body: any = { duration: extendTime };
    if (creditCardInfo) {
      body = {
        ...body,
        creditCard: creditCardInfo
      };
    }
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(body)
      },
    );
  };

  extendReservationWithPaytrail = (
    reservationId: number,
    extendSeconds: number,
    billLater: boolen
  ) => {
    const fetchUrl = `/reservations/${reservationId}/extend-paytrail`;
    let body: any = { duration: extendSeconds, payment: !billLater };
    
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(body)
      },
    );
  };

  manualCallbackPaytrail = (
    reservationId: number,
    paymentreference: string,
  ) => {
    const fetchUrl = `/reservations/${reservationId}/manual-callback-paytrail`;
    let body: any = { paymentreference };

    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(body)
      },
    );
  };

  payExtensionWithCreditCard = () => {
    return new Promise((resolve, reject) =>
      reject("API payExtensionWithCreditCard Endpoint not implemented yet")
    );
  };

  getServicesPurchased = (reservationId: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const fetchUrl = `/reservations/${reservationId}/insurance-taken`;
    return this.fetchCustom(fetchUrl)
  };

  getServicesForSale = (reservationId: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const fetchUrl = `/reservations/${reservationId}/insurance`;
    return this.fetchCustom(fetchUrl)
  };

  payServicesWithCreditCard = (reservationId: number, creditCardInfo: CreditCard, services: any[], cents: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    // const fetchUrl = `/reservations/${reservationId}/purchase-additional-services`;
  }

  payServicesWithPaytrail = (reservationId: number, services: any[], cents: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const fetchUrl = `/reservations/${reservationId}/purchase-additional-services-paytrail`;

    const body = {
      services,
      centsCalculated: cents
    }
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(body)
      },
    );
  }

  openGate = (reservationId: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const fetchUrl = `/reservations/${reservationId}/open-gate`;

    const body = {
      
    }
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(body)
      },
    );
  }

  cancelReservation = (reservationId: number) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const fetchUrl = `/reservations/${reservationId}/cancel`;

    const body = {};
    return this.fetchCustom(
      fetchUrl,
      {
        method: "POST",
        body: JSON.stringify(body)
      },
    );
  };

  getReservedTimePeriods = (reservationId: number, startDateTime: string, endDateTime: string) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const params = `?startDate=${startDateTime}&endDate=${endDateTime}`;
    const fetchUrl = `/reservations/${reservationId}/reserved-time-periods`;
    return this.fetchCustom(fetchUrl+params)
  }
  
  getAdjustmentPrice = (reservationId: number, startDateTime: string, endDateTime: string) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    const params =`?startDate=${startDateTime}&endDate=${endDateTime}`;
    const fetchUrl = `/reservations/${reservationId}/time-adjust`;
    return this.fetchCustom(fetchUrl+params)
  }
  
  payAdjustmentWithPaytrail = (reservationId: number, startDateTime: string, endDateTime: string, centsCalculated :number, payNow: boolean) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    //encodeURIComponent
    const params = `?startDate=${startDateTime}&endDate=${endDateTime}&centsCalculated=${centsCalculated}&payment=${payNow}`;
    const fetchUrl = `/reservations/${reservationId}/time-adjust-paytrail`;
    return this.fetchCustom(fetchUrl+params)
  }
  
  getPaytrailUrl = (reservationId: number, phoneNumber? : string) => {
    if (reservationId <= 0) {
      return new Promise((res, rej) => rej("Invalid reservation number"))
    }
    //encodeURIComponent
    let fetchUrl = `/reservations/${reservationId}/get-paytrail-url`;
    if (phoneNumber !== "")
      fetchUrl += '?phonenumber='+phoneNumber;
    return this.fetchCustom(fetchUrl)
  }
  
  sendDriverLoginLink = (reservationId: number) => {
   if (reservationId <= 0) {
     return new Promise((res, rej) => rej("Invalid reservation number"))
   }
   const fetchUrl = `/reservations/${reservationId}/send-login-url-to-driver`;
 
   const body = {
     
   }
   return this.fetchCustom(
     fetchUrl,
     {
       method: "POST",
       body: JSON.stringify(body)
     },
   );
 }
}

const removeFlagFromFeedback = (feedback: string): boolean => {
  // an array of phrases that means the feedback shouldn't be flagged or recorded
  const phrasesToNotFlag = [
    "Toimintoa ei voitu suorittaa. Ohjelmistosta johtuva yhteyden keskeytys",
    "Verkkoyhteys katkesi",
    "The network connection was lost",
    "Failed to fetch",
    "The operation couldn’t be completed. Software caused connection abort",
    "NetworkError when attempting to fetch resource",
    "Määriteltyä palvelinta ei löytynyt",
    "The Internet connection appears to be offline"
  ];

  return phrasesToNotFlag.some(phrase => {
    return feedback.includes(phrase);
  });
};


export default V3ReservationApi;
